// extracted by mini-css-extract-plugin
export default {"overlay":"pMUccFN9","copy":"auCNtLQ4","wrap":"a44ZN3hD","wrapOn":"jq1KLfVD","content":"L95Dh7wN","hidden":"zctwFUQ8"};